import React from 'react';
import Styled from 'styled';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import defaultStyles from './markdown-cheat-sheet.scss';
import Markdown from 'four-nets/ui-v2/markdown/markdown';

interface Props {
    styles: typeof defaultStyles;
}

const MarkdownCheatSheet: React.FC<Props> = props => {
    const { styles } = props;

    return (
        <div className={styles.cheatSheet}>
            <div className={styles.heading}>
                <FormattedMessage id='TEXT_FORMATTING_OPTIONS' />
            </div>
            <FormattedMessage id='HEADING'>
                {msg => (
                    <div className={styles.row}>
                        <div className={styles.col}>{msg}</div>
                        <div className={classnames(styles.col, styles.syntax)}># {msg}</div>
                        <div className={classnames(styles.col, styles.example)}>
                            <Markdown>{`# ${msg}`}</Markdown>
                        </div>
                    </div>
                )}
            </FormattedMessage>
            <FormattedMessage id='BOLD'>
                {msg => (
                    <div className={styles.row}>
                        <div className={styles.col}>{msg}</div>
                        <div className={classnames(styles.col, styles.syntax)}>**{msg}**</div>
                        <div className={classnames(styles.col, styles.example)}>
                            <Markdown>{`**${msg}**`}</Markdown>
                        </div>
                    </div>
                )}
            </FormattedMessage>
            <FormattedMessage id='ITALIC'>
                {msg => (
                    <div className={styles.row}>
                        <div className={styles.col}>{msg}</div>
                        <div className={classnames(styles.col, styles.syntax)}>*{msg}*</div>
                        <div className={classnames(styles.col, styles.example)}>
                            <Markdown>{`*${msg}*`}</Markdown>
                        </div>
                    </div>
                )}
            </FormattedMessage>
            <FormattedMessage id='LIST'>
                {msg => (
                    <div className={styles.row}>
                        <div className={styles.col}>{msg}</div>
                        <div className={classnames(styles.col, styles.syntax)}>
                            - {msg} 1<br />- {msg} 2<br />- {msg} 3
                        </div>
                        <div className={classnames(styles.col, styles.example)}>
                            <Markdown>
                                {`- ${msg} 1 
- ${msg} 2 
- ${msg} 3`}
                            </Markdown>
                        </div>
                    </div>
                )}
            </FormattedMessage>
            <FormattedMessage id='LINE'>
                {msg => (
                    <div className={styles.row}>
                        <div className={styles.col}>{msg}</div>
                        <div className={classnames(styles.col, styles.syntax)}>---</div>
                        <div className={classnames(styles.col, styles.example)}>
                            <Markdown>{`---`}</Markdown>
                        </div>
                    </div>
                )}
            </FormattedMessage>
            <FormattedMessage id='LINK'>
                {msg => (
                    <div className={styles.row}>
                        <div className={styles.col}>{msg}</div>
                        <div className={classnames(styles.col, styles.syntax)}>[{msg}](https://www.odkaz.sk)</div>
                        <div className={classnames(styles.col, styles.example)}>
                            <Markdown>{`[${msg}](https://www.example.com)`}</Markdown>
                        </div>
                    </div>
                )}
            </FormattedMessage>
        </div>
    );
};

export default Styled(defaultStyles)(MarkdownCheatSheet);
